import React from "react";
import "../App.css";

export default function EngineeringSupport() {
  return (
    <div className="page-in-development" id="engineering-support">
      <h4>Данная страница находится в разработке</h4>
    </div>
  );
}
